import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 100px 20px;
    min-height: 100dvh;
    background: ${props => props?.background_color ? `linear-gradient(to bottom, ${props?.background_color} 35%, ${props?.background_color}70 85%, #292929)` : "transparent"};

    .image-background {
        position: fixed;
        top: 0;
        left: 0;
        width: 100dvw;
        height: 100dvh;
        background-position: center;
        background-size: 100%;
        filter: blur(10px);
        opacity: .3;
        z-index: -1;
    }

    @media (max-width: 800px) {
        padding: 80px 20px;
    }

    @media (max-width: 600px) {
        padding: 70px 10px;
    }
`;

export const Content = styled.div`

    display: flex;
    flex-direction: column;
    position: relative;
    max-width: 1200px;

    h1 {
        font-size: 2rem;
        margin: 5px 0 10px 0;
    }

    .main-image {
        aspect-ratio: 16/6;
        width: 100%;
        border-radius: 10px;
        object-fit: cover;
        box-shadow: 0 0 20px #00000050;
    }

    .header-details-movie {
        margin-top: 20px;
    }

    .span-new-episodes {
        font-size: .7rem;
        text-transform: uppercase;
        letter-spacing: .5px;
        font-weight: 600;
    }

    .header-details-movie footer {
        display: flex;
        align-items: center;
    }

    .link-watch {
        padding: 10px 20px;
        margin-right: 10px;
        font-weight: 700;
        font-size: 1rem;
        border-radius: 50px;
        background: #fff;
        color: #181818;
        border: none;
        cursor: pointer;
        text-decoration: none;
        transition: all .2s ease;
    }
    
    .link-watch:hover {
        background: #aaa;
    }
    
    .link-watch i {
        font-size: .8rem;
    }
    
    .link-watch small {
        margin-left: 5px;
    }

    .movie-details {
        margin-top: 20px;
    }

    .span-assistir-filmes-series {
        font-size: .8rem;
        text-transform: uppercase;
        color: #fff;
        letter-spacing: .5px;
        font-weight: 600;
        margin-right: 10px;
    }

    .span-lancamento-nova-temporada {
        font-weight: 600;
        font-size: .8rem;
        margin-top: .2rem;
    }

    .informacoes-movie-assistir {
        display: flex;
        align-items: center;
        max-width: 100%;
        margin-bottom: 15px;
    }

    .informacoes-movie-assistir .swiper {
        padding-right: 15px !important;
        width: 50dvw !important;
        max-width: 1200px !important;
        overflow: hidden;
    }

    .informacoes-movie-assistir .swiper-slide {
        margin-right: 8px !important;
    }

    .informacoes-movie-assistir section {
        min-height: min-content;
        border-radius: 3rem;
        font-weight: 600;
        font-size: .8rem;
        text-transform: uppercase;
        cursor: default;
        transition: all .3s ease;
    }

    .informacoes-movie-assistir section:hover {
        opacity: .7;
    }

    .informacoes-movie-assistir section:last-child {
        margin-right: 0;
    }

    .informacoes-movie-assistir .section-temporadas {
        display: flex;
    }

    .informacoes-movie-assistir section span {
        white-space: nowrap;
    }

    .descricao-movie-assistir {
        font-size: .85rem;
        font-weight: 500;
        color: #fff;
        margin-bottom: .5rem;
    }

    .container-tags {
        display: flex;
        max-width: 95dvw;
        overflow-x: auto;
        margin-top: 20px;
    }

    .container-tags::-webkit-scrollbar {
        display: none;
    }

    .container-tags span {
        margin-right: 10px;
        font-size:.75rem;
        white-space: nowrap;
    }

    .container-detalhes-movie .release-date-assistir {
        opacity: 0.5;
    }

    .div-label-movies {
        margin-top: 30px;
        border-bottom: 2px solid #00000050;
    }

    .div-label-movies button {
        position: relative;
        background: unset;
        color: #ccc;
        border: none;
        font-size: 1rem;
        padding: 10px 15px;
        cursor: pointer;
    }

    .div-label-movies button:hover {
        background: #00000050;
    }

    .div-label-movies .active {
        color: #fff;
    }

    .div-label-movies .active::after {
        content: '';
        position: absolute;
        bottom: -2px;
        left: 0;
        background: #fff;
        height: 2px;
        width: 100%;

    }

    @media (max-width: 600px) {
        
        .main-image {
            aspect-ratio: 16/8;
            width: 100%;
            border-radius: 10px;
            object-fit: cover;
        }

    }

`;

export const ButtonProvider = styled.a `
    background: ${props => props.background_color ? props.background_color : "#fff"};
    color: ${props => props.text_color ? props.text_color : "#000"};
    display: flex;
    align-items: center;
    padding: 10px 20px;
    margin-right: 10px;
    font-weight: 700;
    font-size: 1rem;
    border-radius: 50px;
    border: 1px solid #aaa;
    cursor: pointer;
    text-decoration: none;
    transition: all .2s ease;
    
    &:hover {
        background: ${props => props.background_color ? props.background_color : "#aaaaaa"}aa;
    }
    
    img {
        height: 19px;
    }
    
     small {
        margin-left: 5px;
    }
`;

export const Back = styled(Link) `
    position: fixed;
    top: 20px;
    left: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #00000050;
    color: #aaa;
    width: 40px;
    height: 40px;
    border-radius: 50px;
    border: 2px solid #aaa;
    text-decoration: none;
    transition: all .3s ease;
    z-index: 9999;

    &:hover {
        background: #000;
        color: #fff;
        border-color: #fff;
    }
`

export const ErrorMessage = styled.div`
    font-size: .9rem;
    color: #fff;
    font-weight: 600;
    background-color: ${props => props.background ? props.background : "#303030"};
    padding: 10px;
    border-radius: 8px;
    text-align: center;
    margin: ${props => props.margin ? props.margin : "#303030"};
`;

export const ContainerIframe = styled.div `
    position: fixed;
    top: 0;
    left: 0;
    width: 100dvw;
    height: 100dvh;
    background: #000;
    z-index: 999;

    iframe {
        min-width: 100%;
        min-height: 100%;
    }

`